// @ts-nocheck
export function activePage() {
  const headerLinks = document.querySelectorAll(".header-nav-list__link");
  const footerLinks = document.querySelectorAll(".footer-list__link");

  for (let i = 0; i < headerLinks.length; i++) {
    const link = headerLinks[i];
    link.classList.remove("page-active");
  }

  for (let i = 0; i < footerLinks.length; i++) {
    const link = footerLinks[i];
    link.classList.remove("page-active");
  }

  if (document.getElementById("mainPage")) {
    headerLinks[0].classList.add("page-active");
    footerLinks[0].classList.add("page-active");
  }
  if (document.getElementById("usefulPage")) {
    headerLinks[1].classList.add("page-active");
    footerLinks[1].classList.add("page-active");
  }
  if (document.getElementById("certificatesPage")) {
    headerLinks[2].classList.add("page-active");
    footerLinks[2].classList.add("page-active");
  }
  if (document.getElementById("deliveryPage")) {
    headerLinks[3].classList.add("page-active");
    footerLinks[3].classList.add("page-active");
  }
  if (document.getElementById("contactsPage")) {
    headerLinks[4].classList.add("page-active");
    footerLinks[4].classList.add("page-active");
  }
}
